var exports = {
  "I": "blankslate__HriF1Z",
};

module.exports = exports;
